class SearchItem {
  constructor(name, code, slug) {
    this.name = typeof name === 'undefined' ? '' : name
    this.code = typeof code === 'undefined' ? '' : code
    this.slug = typeof slug === 'undefined' ? '' : slug
  }
}

export default SearchItem
